// Mock auth simulating ShelfLife's existing admin role gate.
// In production, this would be replaced by ShelfLife's real auth context
// (e.g. useAuth() returning the logged-in user + role). Behavior: only users
// with role === "admin" can render the Operator Console. No hardcoded passwords.
import { createContext, useContext, useMemo } from "react";
import { MOCK_ADMIN_USER } from "./mockData";

const MockAuthContext = createContext(null);

export const MockAuthProvider = ({ children, overrideUser }) => {
  const value = useMemo(
    () => ({
      // Simulate Rafael being already signed in as an Admin in ShelfLife.
      // Swap MOCK_ADMIN_USER -> null to preview the denial state.
      user: overrideUser === undefined ? MOCK_ADMIN_USER : overrideUser,
      isAuthenticated: !!(overrideUser === undefined ? MOCK_ADMIN_USER : overrideUser),
      isAdmin:
        (overrideUser === undefined ? MOCK_ADMIN_USER?.role : overrideUser?.role) ===
        "admin",
    }),
    [overrideUser]
  );

  return (
    <MockAuthContext.Provider value={value}>{children}</MockAuthContext.Provider>
  );
};

export const useMockAuth = () => {
  const ctx = useContext(MockAuthContext);
  if (!ctx) {
    // Sensible default if provider missing — treat as unauthenticated.
    return { user: null, isAuthenticated: false, isAdmin: false };
  }
  return ctx;
};
